import { render, staticRenderFns } from "./DropdownPrioridadeAgrupamento.vue?vue&type=template&id=23e6924d&scoped=true"
import script from "./DropdownPrioridadeAgrupamento.vue?vue&type=script&lang=js"
export * from "./DropdownPrioridadeAgrupamento.vue?vue&type=script&lang=js"
import style0 from "./DropdownPrioridadeAgrupamento.vue?vue&type=style&index=0&id=23e6924d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e6924d",
  null
  
)

export default component.exports